"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapObservable = exports.mergeObservables = exports.Subject = void 0;
class Subject {
  constructor(initialValue) {
    this.subscribers = new Set();
    this.lastValue = initialValue;
  }
  get value() {
    return this.lastValue;
  }
  next(value) {
    if (this.lastValue === value) {
      return;
    }
    this.lastValue = value;
    this.subscribers.forEach(callback => {
      try {
        callback(value);
      } catch (e) {}
    });
  }
  subscribe(callback) {
    this.subscribers.add(callback);
    return () => {
      this.subscribers.delete(callback);
    };
  }
}
exports.Subject = Subject;
const mergeObservables = function () {
  for (var _len = arguments.length, observables = new Array(_len), _key = 0; _key < _len; _key++) {
    observables[_key] = arguments[_key];
  }
  const state = observables.map(observable => observable.value);
  const res = new Subject([...state]);
  observables.map((observable, index) => {
    observable.subscribe(value => {
      state[index] = value;
      res.next([...state]);
    });
  });
  return res;
};
exports.mergeObservables = mergeObservables;
const mapObservable = (input, mapFn) => {
  const res = new Subject(typeof input.value === 'undefined' ? undefined : mapFn(input.value));
  input.subscribe(value => {
    res.next(mapFn(value));
  });
  return res;
};
exports.mapObservable = mapObservable;